import type { UtmData } from '~/schemas/utm'
import { fetchApi } from './helpers'

/**
 * The landing beacon (BOAT-1897).
 *
 * The one request the storefront makes purely to record something, and the
 * only reason it earns its place: a visit is the DENOMINATOR every attribution
 * figure we have has been missing. Without it "Klaviyo produced £40k" is the
 * whole story, and whether Klaviyo converts better than paid search is
 * unanswerable.
 *
 * It carries the device block and both touches, so a landing costs one round
 * trip rather than three, and the API writes the device, the visit and the
 * attribution from it together.
 */
export const recordVisit = (body: {
  device: { visitor_id: string; components?: Record<string, unknown> }
  utm?: UtmData
  first_touch_utm?: UtmData
  landing_url?: string
  referrer?: string
  consent_state?: string
}) =>
  fetchApi(`/visits`, {
    method: 'POST',
    body,
  })
